import { Button } from '@edsn/pie-components';
import { useTranslation } from 'react-i18next';
import { Dialog } from '#pie/components/layout/dialog/Dialog';
import { Text } from '#pie/components/text/Text';

export const TicketTemplateDialog = ({
  showConfirm,
  closeConfirm,
  onConfirmClick,
}: {
  showConfirm: boolean;
  closeConfirm: () => void;
  onConfirmClick: () => void;
}) => {
  const { t } = useTranslation();
  const { t: transtic } = useTranslation('ticket');

  return (
    <Dialog
      open={showConfirm}
      title={transtic('create.categories.switch_category')}
      onOpenChange={closeConfirm}
    >
      <Text className="mb-6">
        {transtic('create.categories.switch_category_warning')}
      </Text>
      <form onSubmit={onConfirmClick}>
        <div className="grid grid-cols-2 gap-4">
          <Button action="tertiary" emphasis="subtle" type="submit">
            {t('common.ignore_changes')}
          </Button>
          <Button action="secondary" emphasis="bold" onClick={closeConfirm}>
            {t('common.save_changes')}
          </Button>
        </div>
      </form>
    </Dialog>
  );
};
